import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
// Styles
import styles from '../index.module.sass';

export default function Item({ val, history, setOpen, selected, setItemSelected, itemSelected }) {
  const { location = {} } = history;
  const { hash = '' } = location;
  const { children, id, index } = val;

  const cont = process.env.REACT_APP_COUNTRY;

  const { t } = useTranslation('menuheader');

  return (
    <div
      className={`${styles.departamentContainer} ${styles[itemSelected === selected]}`}
      onClick={() => {
        if (itemSelected === selected) setItemSelected(null);
        else setItemSelected(selected);
      }}
      style={{
        order: index,
        width: `100%`,
      }}>
      {id === 'account' ? (
        <></>
      ) : (
        <Link
          to={`${val.url}${hash}`}
          className={`${styles.departament} ${styles[itemSelected === selected]} ${
            children.length > 0 && styles.haveChildren
          }`}
          onClick={(e) => {
            if (children.length > 0) e.preventDefault();
            else setOpen(false);
          }}>
          {id === 'shipments' ? (
            <span className={styles.iconShipment}>
              <span className={`material-icons-outlined`}>local_shipping</span>
              &nbsp;{t(id)}
            </span>
          ) : (
            <span>{t(id)}</span>
          )}
          {children.length > 0 && (
            <span className={`material-icons-outlined ${styles.itemIcon}`}>expand_more</span>
          )}
        </Link>
      )}

      <div
        className={`${styles.families} ${
          styles[itemSelected === selected && children.length > 0]
        }`}>
        {children.map((subval, subkey) => {
          const external = (
            <a
              className={styles.familyTitle}
              key={subkey}
              href={`${subval.url}`}
              target='_blank'
              rel='noopener noreferrer'
              onClick={() => {
                setItemSelected(null);
                setOpen(false);
              }}>
              <span className={`material-icons ${styles.familyIcon}`}>
                {subval?.icon || 'arrow_right_alt'}
              </span>
              {t(subval.id)}
            </a>
          );

          const normal = (
            <Link
              className={styles.familyTitle}
              key={subkey}
              to={`${val.url}${subval.url}${hash}`}
              onClick={() => {
                setItemSelected(null);
                setOpen(false);
              }}>
              <span className={`material-icons ${styles.familyIcon}`}>
                {subval?.icon || 'arrow_right_alt'}
              </span>
              {t(subval.id)}
            </Link>
          );

          if (subval.external) {
            if (subval.country && subval.country === cont) return external;
            else if (subval.country && subval.country !== cont) return null;
            else return external;
          } else {
            if (subval.country && subval.country === cont) return normal;
            else if (subval.country && subval.country !== cont) return null;
            else return normal;
          }
        })}
      </div>
    </div>
  );
}
